import { ChildrenContainer, StyledEmptyStateContainer } from './styled';
import { EmptyStateContainerProps } from './types';

function EmptyStateContainer({ children }: EmptyStateContainerProps) {
  return (
    <StyledEmptyStateContainer>
      <ChildrenContainer>{children}</ChildrenContainer>
    </StyledEmptyStateContainer>
  );
}

export { EmptyStateContainer };
